import React, { useContext, useState } from 'react';

import { devolverDemanda } from '@app/api/demanda';
import { Button, FormatText, FormTextArea, FormSubmitButton, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal } from 'antd';
import * as Yup from 'yup';
import QuestionarioContextProvider from '../../../../hooks/useQuestionario';

interface Props {
  onUpdate: any;
}

function ModalDevolverDemanda(props: Props) {
  const { onUpdate } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const { demandaData } = useContext(QuestionarioContextProvider);

  const handleSubmit = (values: any) => {
    if (demandaData) {
      devolverDemanda({ id: demandaData.id, justificativa: values.justificativa }).then(data => {
        if (data.valid) {
          setExibirModal(false);
          onUpdate();
        }
      });
    }
  };

  return (
    <>
      <>
        <Button
          id='mrn-button-modal-ModalDevolverDemanda-devolver'
          type="danger"
          onClick={() => {
            setExibirModal(true);
          }}>
          Devolver
        </Button>
      </>
      <Modal
        title="Devolver Demanda"
        width="690px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formDevolucao"
          onSubmit={handleSubmit}
          actions={[
            <Button
              id='mrn-button-modal-ModalDevolverDemanda-fechar'
              type="link"
              onClick={() => {
                setExibirModal(false);
              }}
              key="close">
              Fechar
            </Button>,
            <FormSubmitButton
              id='mrn-button-modal-ModalDevolverDemanda-salvar'
              noIcon type="primary" key="save">
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <Row>
              <FormTextArea
                id='mrn-textarea-modal-ModalDevolverDemanda-devolver'
                name="justificativa"
                label="Justificativa"
                span={12}
                validateSchema={Yup.string().trim().required('Campo requerido.')}
                rows={4}
                maxLength={4000}
              />
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
}

export default ModalDevolverDemanda;
